import { render, staticRenderFns } from "./WalletSummaryCard.vue?vue&type=template&id=6055278e&scoped=true"
import script from "./WalletSummaryCard.vue?vue&type=script&lang=js"
export * from "./WalletSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./WalletSummaryCard.vue?vue&type=style&index=0&id=6055278e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055278e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6055278e')) {
      api.createRecord('6055278e', component.options)
    } else {
      api.reload('6055278e', component.options)
    }
    module.hot.accept("./WalletSummaryCard.vue?vue&type=template&id=6055278e&scoped=true", function () {
      api.rerender('6055278e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/WalletSummaryCard.vue"
export default component.exports